// Required by CJS deps expecting a Node-style `global` in browser runtime.

(window as any).global ??= window;

import('./bootstrap').catch(err => console.error(err));
